
<template>
  <div>
    <span v-html="formattedString"></span>
    <span v-show="text.length > maxChars"></span>
    <a
      :href="link"
      id="readmore"
      v-show="!isReadMore && this.text.length > this.maxChars"
      v-on:click="triggerReadMore($event, true)"
    >
      <font-awesome-icon :icon="moreIcon" v-if="showIcon" />
      {{moreStr}}
    </a>
    <a
      :href="link"
      id="readmore"
      v-show="isReadMore && this.text.length > this.maxChars"
      v-on:click="triggerReadMore($event, false)"
    >
      <font-awesome-icon :icon="lessIcon" v-if="showIcon" />
      {{lessStr}}
    </a>
  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
export default {
  name: 'XVreadmore',
  mixins: [FAMixin],
  props: {
    moreStr: {
      type: String
    },
    lessStr: {
      type: String
    },
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: '#'
    },
    maxChars: {
      type: Number,
      default: 100
    },
    moreIcon: {
      type: String,
      default: 'chevron-down'
    },
    lessIcon: {
      type: String,
      default: 'chevron-up'
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isReadMore: false
    }
  },
  computed: {
    formattedString() {
      var valContainer = this.text
      if (!this.isReadMore && this.text.length > this.maxChars) {
        let maxCharsSpace = this.text.indexOf(' ', this.maxChars)
        let maxCharsDot = this.text.indexOf('.', this.maxChars)
        let maxCharsClosesd = this.maxChars
        if (maxCharsSpace !== -1 && maxCharsDot !== -1) {
          maxCharsClosesd = Math.max(Math.min(maxCharsSpace, maxCharsDot), 0)
        } else if (maxCharsSpace === -1 && maxCharsDot !== -1) {
          maxCharsClosesd = maxCharsDot
        } else if (maxCharsSpace !== -1 && maxCharsDot === -1) {
          maxCharsClosesd = maxCharsSpace
        }
        valContainer = valContainer.substring(0, maxCharsClosesd) + '...'
      }
      return valContainer
    }
  },
  methods: {
    triggerReadMore(e, b) {
      if (this.link === '#') {
        e.preventDefault()
      }
      if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b
    }
  }
}
</script>
